import { FC, SVGProps } from "react";

export const DiscountItemSvg: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12.7876 21.5029L2.99756 11.7129V13.7129C2.99756 14.2429 3.20756 14.7529 3.58756 15.1229L11.3776 22.9129C12.1576 23.6929 13.4276 23.6929 14.2076 22.9129L20.4176 16.7029C21.1976 15.9229 21.1976 14.6529 20.4176 13.8729L12.7876 21.5029Z" />
    <path d="M11.3776 17.9129C11.7676 18.3029 12.2776 18.5029 12.7876 18.5029C13.2976 18.5029 13.8076 18.3029 14.1976 17.9129L20.4076 11.7029C21.1876 10.9229 21.1876 9.65293 20.4076 8.87293L12.6176 1.08293C12.2476 0.71293 11.7376 0.50293 11.2076 0.50293H4.99756C3.89756 0.50293 2.99756 1.40293 2.99756 2.50293V8.71293C2.99756 9.24293 3.20756 9.75293 3.58756 10.1229L11.3776 17.9129ZM4.99756 2.50293H11.2076L18.9976 10.2929L12.7876 16.5029L4.99756 8.71293V2.50293Z" />
    <path d="M7.24756 6.00293C7.93791 6.00293 8.49756 5.44329 8.49756 4.75293C8.49756 4.06257 7.93791 3.50293 7.24756 3.50293C6.5572 3.50293 5.99756 4.06257 5.99756 4.75293C5.99756 5.44329 6.5572 6.00293 7.24756 6.00293Z" />
  </svg>
);
